import React, {createContext, useCallback, useContext, useEffect, useMemo, useState} from 'react';
import {initial} from "../../../common/domain/RemoteData.model";
import {remoteDataWithSetter} from "../../../common/utils/remoteDataWithSetter";
import {fetchFilterData} from "./FilterService";

const FilterContext = createContext();
FilterContext.displayName = 'FilterContext';

export const useFilterContext = () => useContext(FilterContext);

export const FilterContextProvider = ({initialFilters = {}, children}) => {
    const [filterOptionsRemoteData, setFilterOptionsRemoteData] = useState(initial([]));
    const [filters, setFilters] = useState(initialFilters);

    useEffect(() => {
        remoteDataWithSetter(setFilterOptionsRemoteData, fetchFilterData).then();
    }, []);


    const updateFilters = useCallback((newFilters) => {
        if (typeof newFilters === 'object' && newFilters !== null) {
            setFilters({...newFilters});
        }
    }, []);

    const clearFilters = useCallback(() => setFilters({}), []);

    const context = useMemo(() => ({
        filters,
        updateFilters,
        clearFilters,
        filterOptionsRemoteData,
        setFilterOptionsRemoteData,
    }), [filters, updateFilters, clearFilters, filterOptionsRemoteData]);

    return (
        <FilterContext.Provider value={context}>
            {children}
        </FilterContext.Provider>
    );
};
